// The signed-in CSR's name for every box that signs with it (2026-10-30,
// docs/decisions/2026-10-30-restored-work-signature-owner.md). Pure helpers;
// the hook is useSignedInIdentity.js.
//
// The name came from useMsal()'s accounts[0], the first account in the
// browser's MSAL cache, while API calls use the ACTIVE account. A browser
// that ever had a second account signed in could then show one person's name
// while the server sent as another. The name now comes from the signed-in
// identity: /api/me (what the server itself signs with), else MSAL's active
// account. Never accounts[0].

import { firstNameOf } from '@cxhub/shared'

export { firstNameOf }

// me: /api/me's body ({ name, username }); activeAccount: MSAL's
// getActiveAccount(). useMe false: /api/me is not used (the e2e build, see
// the hook).
export function signedInName({ me = null, activeAccount = null, useMe = true } = {}) {
  const fromMe = useMe ? (me?.name || me?.username || '') : ''
  if (fromMe) return fromMe
  return activeAccount?.name || activeAccount?.username || ''
}

export function signedInFirstName(args) {
  return firstNameOf(signedInName(args))
}
